export default __webpack_public_path__ + "static/media/smedetoften-tenancy-10.9bd63865.jpg";